import { render, staticRenderFns } from "./PackageClaimUpdateStatus.vue?vue&type=template&id=46ee271e&"
import script from "./PackageClaimUpdateStatus.vue?vue&type=script&lang=js&"
export * from "./PackageClaimUpdateStatus.vue?vue&type=script&lang=js&"
import style0 from "./PackageClaimUpdateStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageClaimUpdateStatus.vue"
export default component.exports